// extracted by mini-css-extract-plugin
export var productImage = "_zr-0";